import {
  ArrowIcon,
  Box,
  Button,
  ContextMenu,
  ContextMenuItem,
  ContextMenuList,
  ContextMenuTrigger,
  Flex,
  SquareButton,
  Text,
  Tooltip,
} from '@modusign/design-system';
import { useState } from 'react';

import useTemplatePermission from '@app/features/template/hooks/useTemplatePermission';

interface TemplateSaveButtonProps {
  error: boolean;
  isLoading: boolean;
  onSaveAsCopyClick: () => void;
  onSaveClick: () => void;
}

export default function TemplateSaveButton({
  error,
  isLoading,
  onSaveAsCopyClick,
  onSaveClick,
}: TemplateSaveButtonProps) {
  const [isOpenTextOptions, setIsOpenTextOptions] = useState(false);

  const { createTemplatePermission } = useTemplatePermission();

  const handleCloseTextOptions = () => {
    setIsOpenTextOptions((v) => !v);
  };

  return (
    <Flex flexDirection="row">
      <Button
        disabled={error}
        height="48px"
        isLoading={isLoading}
        sx={{ borderBottomRightRadius: '0', borderTopRightRadius: '0' }}
        variant="primary"
        width="148px"
        onClick={onSaveClick}
      >
        이대로 저장
      </Button>
      <Box minWidth="32px" position="absolute" right={0}>
        <ContextMenu isOpen={isOpenTextOptions} onOpenChange={setIsOpenTextOptions}>
          <ContextMenuTrigger>
            <SquareButton
              disabled={isLoading || error}
              sx={{
                backgroundColor: 'buttonBackgroundPrimaryBase',
                borderBottomLeftRadius: '0',
                borderTopLeftRadius: '0',
                borderStyle: 'none',
                color: 'textNeutralBase',
                height: '48px',
                textAlign: 'center',
                width: '36px',
                '&:hover': {
                  backgroundColor:
                    isLoading || error
                      ? 'buttonBackgroundNeutralBase'
                      : 'buttonBackgroundPrimaryLight',
                },
              }}
            >
              <ArrowIcon direction="down" />
            </SquareButton>
          </ContextMenuTrigger>
          <ContextMenuList minWidth="160px" mt={0} top="-63px">
            <ContextMenuItem
              color="textNeutralSlightlyLight"
              disabled={!createTemplatePermission.isPermitted}
              value="사본으로 저장"
              onClick={() => {
                onSaveAsCopyClick();
                handleCloseTextOptions();
              }}
            >
              <Tooltip
                content={createTemplatePermission.message}
                disabled={createTemplatePermission.isPermitted}
                placement="left"
              >
                <Text as="p">사본으로 저장</Text>
              </Tooltip>
            </ContextMenuItem>
          </ContextMenuList>
        </ContextMenu>
      </Box>
    </Flex>
  );
}
